import React, { memo, useCallback, useContext } from 'react';
import { action } from 'mobx';
import TableContext from './TableContext';
import Dropdown from '../dropdown/Dropdown';
import Menu from '../menu';
import { $l } from '../locale-context';
const AggregationButton = function AggregationButton(props) {
    const { expanded, record, columnGroup } = props;
    const { tableStore, prefixCls } = useContext(TableContext);
    const handleMenuClick = useCallback(action(({ key }) => {
        switch (key) {
            case 'cell':
                tableStore.setAggregationCellExpanded(record, columnGroup.key, !expanded);
                break;
            case 'row':
                tableStore.columnGroups.allLeafs.forEach(({ column: col, key: columnKey }) => col.aggregation && tableStore.setAggregationCellExpanded(record, columnKey, !expanded));
                break;
            case 'column': {
                const { dataSet } = record;
                if (dataSet) {
                    dataSet.forEach(r => tableStore.setAggregationCellExpanded(r, columnGroup.key, !expanded));
                }
                break;
            }
            default:
        }
    }), [tableStore, record, columnGroup, expanded]);
    const handleClick = useCallback(() => {
        handleMenuClick({ key: tableStore.aggregationExpandType });
    }, [handleMenuClick, tableStore]);
    const getOverlay = useCallback(() => (React.createElement(Menu, { prefixCls: `${prefixCls}-dropdown-menu`, onClick: handleMenuClick },
        React.createElement(Menu.Item, { key: "cell" }, $l('Table', expanded ? 'collapse_cell' : 'expand_cell')),
        React.createElement(Menu.Item, { key: "row" }, $l('Table', expanded ? 'collapse_row' : 'expand_row')),
        React.createElement(Menu.Item, { key: "column" }, $l('Table', expanded ? 'collapse_column' : 'expand_column')))), [prefixCls, handleMenuClick, expanded]);
    return (React.createElement("span", { className: `${prefixCls}-cell-expand` },
        React.createElement("button", { type: "button", className: `${prefixCls}-cell-expand-btn`, onClick: handleClick }, $l('Table', expanded ? 'collapse' : 'expand_button')),
        React.createElement(Dropdown, { overlay: getOverlay },
            React.createElement("span", { className: `${prefixCls}-cell-expand-menu-btn` }))));
};
AggregationButton.displayName = 'AggregationButton';
export default memo(AggregationButton);
